import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { EtiquetasTrazabilidadService } from './etiquetas-trazabilidad.service';

@Component({
  selector: 'app-etiquetas-trazabilidad',
  templateUrl: './etiquetas-trazabilidad.component.html',
  styleUrls: ['./etiquetas-trazabilidad.component.scss']
})
export class EtiquetasTrazabilidadComponent implements OnInit {

  public inputOps: string = '';
  public parsedOrders: string[] = [];
  public flagResult: boolean = false;
  public pdfBlobUrl: string | null = null;
  public safePdfUrl: SafeResourceUrl | null = null;
  public startDate: string = new Date().toISOString().slice(0, 10);
  public endDate: string = new Date().toISOString().slice(0, 10);

  constructor(
    private etiquetasService: EtiquetasTrazabilidadService,
    private helpers: HelpersService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.helpers.setTitle('Etiquetas Trazabilidad Física');
  }

  parseOrders(): string[] {
    return this.inputOps
      .split(/[;\n\r,\t]+/)
      .map(op => op.trim())
      .filter(op => op.length > 0);
  }

  async obtenerEtiquetas() {
    this.parsedOrders = this.parseOrders();

    if (this.parsedOrders.length === 0) {
      this.helpers.notifications.warningMessage('Ingresa al menos un número de pedido.');
      return;
    }

    if (!this.startDate || !this.endDate) {
      this.helpers.notifications.warningMessage('Ingresa las fechas de inicio y fin.');
      return;
    }

    this.flagResult = false;
    this.revokeCurrentBlobUrl();

    showSpinner(`Obteniendo etiquetas para ${this.parsedOrders.length} pedido(s)...`);
    const result = await this.etiquetasService.getLabels(this.parsedOrders, this.startDate, this.endDate);
    hideSpinner();

    if (result.success && result.blob) {
      this.pdfBlobUrl = URL.createObjectURL(result.blob);
      this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfBlobUrl);
      this.flagResult = true;
    } else {
      this.helpers.notifications.errorDialog('Error al obtener etiquetas', result.message);
    }
  }

  descargarPdf() {
    if (!this.pdfBlobUrl) return;
    const link = document.createElement('a');
    const fecha = new Date().toISOString().slice(0, 10);
    link.href = this.pdfBlobUrl;
    link.download = `etiquetas_${fecha}.pdf`;
    link.click();
  }

  abrirEnNuevaPestana() {
    if (!this.pdfBlobUrl) return;
    window.open(this.pdfBlobUrl, '_blank');
  }

  limpiar() {
    this.inputOps = '';
    this.parsedOrders = [];
    this.flagResult = false;
    this.safePdfUrl = null;
    this.revokeCurrentBlobUrl();
  }

  private revokeCurrentBlobUrl() {
    if (this.pdfBlobUrl) {
      URL.revokeObjectURL(this.pdfBlobUrl);
      this.pdfBlobUrl = null;
    }
  }

  ngOnDestroy(): void {
    this.revokeCurrentBlobUrl();
  }
}
